import { FC } from 'react';
import Tab, { tabClasses } from '@mui/material/Tab';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import { SxProps, Theme } from '@mui/system';
import TabContext from '@mui/lab/TabContext';
import { TBaseTabs } from './type';

export const tabsStyles = () => ({
  root: {
    backgroundColor: 'transparent',
    minHeight: 44,
  },
  flexContainer: {
    position: 'relative',
    padding: '0',
    zIndex: 1,
  },
  indicator: {
    top: 3,
    bottom: 3,
    right: 3,
    height: 'auto',
    width: 30,
    backgroundColor: '#A855F7',
    boxShadow: '0 4px 12px 0 rgba(0,0,0,0.16)',
  },
});

export const tabItemStyles = (theme: Theme) => ({
  root: {
    fontWeight: 500,
    opacity: 0.7,
    color: theme.palette.mode === 'dark' ? '#A78BFA' : 'rgb(88,27,134)',
    textTransform: 'initial',
    '&:hover': {
      opacity: 1,
    },
    [`&.${tabClasses.selected}`]: {
      color: 'white',
      opacity: 1,
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 120,
    },
  },
});

function toSx(styles: (theme: Theme) => any, classes: any): SxProps<Theme> {
  return function sxCallback(theme: Theme) {
    let sx: any = {};
    Object.entries(styles(theme)).forEach(([key, value]: any) => {
      if (key === 'root') {
        sx = {
          ...sx,
          ...value,
        };
      } else {
        sx[`& .${classes[key]}`] = value;
      }
    });
    return sx;
  };
}

const MobileTabs: FC<TBaseTabs> = ({
  tabs,
  handleChange,
  value,
  children,
  secondaryAction = null,
  isDisplayChildPadding = true,
}) => (
  <TabContext value={value}>
    <Box
      sx={{
        width: '100%',
      }}
    >
      <AppBar
        elevation={1}
        position="absolute"
        sx={{
          top: 70,
          background: 'rgba(168, 85, 247, 0.16)',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Bottom Navigation"
          sx={toSx(tabsStyles, tabsClasses) as SxProps}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              sx={toSx(tabItemStyles, tabClasses) as SxProps}
            />
          ))}
        </Tabs>
      </AppBar>
    </Box>
    <Box pt={isDisplayChildPadding ? 7 : 0}>
      {secondaryAction}
      {children}
    </Box>
  </TabContext>
);

export {
  MobileTabs,
};
